import './ContentTitle.css';
import React, { useRef, useState, useLayoutEffect } from 'react';
import baseline, { appTextStyle } from '../../app-ui/baseline';

// Submitted iOS60 only shows the measured E badge when the full one-line title fits.
export default function MeasuredContentTitle({ title, explicit }) {
  const row = useRef(null),
    natural = useRef(null);
  const [fits, setFits] = useState(false);
  useLayoutEffect(() => {
    if (!explicit) return;
    let active = true;
    const measure = () => {
      if (active && row.current && natural.current) {
        const fontSize = parseFloat(getComputedStyle(row.current).fontSize) || 14;
        setFits(natural.current.offsetWidth + (fontSize * 10) / 14 + 4 <= row.current.clientWidth);
      }
    };
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(row.current);
    observer?.observe(natural.current);
    document.fonts?.ready.then(measure);
    return () => {
      active = false;
      observer?.disconnect();
    };
  }, [title, explicit]);
  return (
    <strong
      ref={row}
      className="pp-content-title"
      style={{
        ...appTextStyle(baseline.contentText.title),
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <span className="pp-content-title-text">{title}</span>
      {explicit && (
        <span
          ref={natural}
          className="pp-measured-title-natural"
          style={{
            position: 'absolute',
            visibility: 'hidden',
            whiteSpace: 'nowrap',
            width: 'max-content',
            pointerEvents: 'none',
          }}
          aria-hidden="true"
        >
          {title}
        </span>
      )}
      {explicit && fits && (
        <small className="pp-explicit" aria-label="Explicit">
          E
        </small>
      )}
    </strong>
  );
}
